import React, { Component } from 'react'
import {
    Container,
    Row,
    Col,
    NavLink,
    UncontrolledTooltip
} from 'reactstrap'

export default class Frameworks extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: 'OUR CODING SOLUTIONS',
            subtitle: 'We use the best coding technologies to support our works',
            frameworks: [{
                name: 'css3',
                display: 'CSS 3',
                desc: 'CSS 3 - The latest evolution of the Cascading Style Sheets language'
            }, {
                name: 'html',
                display: 'HTML 5',
                desc: 'HTML 5 - The latest evolution of the standard that defines HTML'
            }, {
                name: 'bootstrap',
                display: 'Bootstrap',
                desc: 'Bootstrap - Most popular front-end component library'
            }, {
                name: 'jquery',
                display: 'jQuery',
                desc: 'jQuery - JavaScript library designed to simplify HTML DOM tree traversal and manipulation, as well as event handling, CSS animation, and Ajax'
            }, {
                name: 'php',
                display: 'PHP',
                desc: 'PHP - Server scripting language, and a powerful tool for making dynamic and interactive Web pages'
            }, {
                name: 'java',
                display: 'Java',
                desc: 'CSS 3 - A general-purpose programming language that is class-based, object-oriented, and designed to have as few implementation dependencies as possible'
            }, {
                name: 'extjs',
                display: 'ExtJS',
                desc: 'ExtJS - Comprehensive JavaScript framework for building data-intensive, cross-platform web and mobile applications for any modern device'
            }, {
                name: 'react',
                display: 'React JS',
                desc: 'React JS - A JavaScript library for building user interfaces'
            }, {
                name: 'react-native',
                display: 'React Native',
                desc: 'React Native - A JavaScript library for building user interfaces'
            }, {
                name: 'laravel',
                display: 'Laravel',
                desc: 'Laravel - The PHP Framework For Web Artisans'
            }, {
                name: 'android',
                display: 'Android',
                desc: 'Android - A mobile operating system developed by Google'
            }, {
                name: 'ios',
                display: 'iOS',
                desc: 'iOS - A mobile operating system created and developed by Apple Inc'
            }]
        }
    }
    render() {
        return (
            <section className="section section-lg pt-5 bg-gradient-whitey">
                <Container>
                    <Row className="row-grid justify-content-center">
                        <Col className="text-center" lg="8">
                            <div className="text-center">
                                <h4 className="display-4 mb-0 mt-5">{this.state.title}</h4>
                                <h6 className="display-6 mb-5 mt-0">{this.state.subtitle}</h6>
                                <Row className="justify-content-center">
                                    {
                                        this.state.frameworks.map((val, key) => {
                                            return (
                                                <Col key={key} lg="2" xs="4" className="home-frameworks-item-wrap">
                                                    <NavLink href="#" id={`tooltip_${key}`} target="_blank">
                                                        <img alt="..." className="" src={require(`../../assets/images/theme/logo/${val.name}.jpg`)} />
                                                    </NavLink>
                                                    <UncontrolledTooltip delay={0} target={`tooltip_${key}`}>
                                                        {val.desc}
                                                    </UncontrolledTooltip>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    }
}

